module.exports = __webpack_public_path__ + "img/icon_img2.5a271ca6.png";